import styled from 'styled-components';
import colors from '../../theme/search/colors';

const Wrapper = styled.div`
  .bar-zone {
    display: flex;

    @media (max-width: 767px) {
      display: block;
    }

    & .input {
      width: 735px;
      padding-right: 30px;

      @media (max-width: 767px) {
        width: 100%;
        padding-right: 0;
      }
    }

    & .buttonZone {
      padding-top: 15px;
    }
  }

  .separator {
    color: ${colors.graySix};
    font-size: 16px;
    font-family: 'Roboto Condensed';
    font-weight: 700;
    line-height: 19px;
    border-bottom: 1px solid ${colors.graySeven};
    padding-bottom: 5px;
    margin-bottom: 17px;
    margin-top: 13px;
    text-transform: uppercase;
  }
`;

export { Wrapper };



// WEBPACK FOOTER //
// ./src/components/SearchBar/style.js